// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".merchant-queue-text{height:25px;display:flex;justify-content:space-between;align-items:center;padding:12px}.merchant-queue-text-addon{flex:0 0 auto;margin-left:12px}\n", ""]);
// Exports
module.exports = exports;
